<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{'font-weight': 'bold', 'background': '#F0F2F8', 'color': '#333'}"
      element-loading-text="拼命加载中"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="id"
        width="80"
        label="序号"
      >
      </el-table-column> -->
      <el-table-column
        prop="withdrawId"
        label="提现ID"
      />
      <el-table-column
        prop="projectCodeName"
        label="平台"
      />
      <el-table-column
        prop="withdrawAmount"
        label="提现金额"
      >
        <template slot-scope="scope">
          <div>
            <div>￥{{ scope.row.withdrawAmount }}</div>
            <div style="font-size: 12px; color: #999; margin-top: 4px;">
              （含平台实收：¥{{ scope.row.platActualFee || 0 }}及平台补贴：¥{{ scope.row.platCouponFee || 0 }}）
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="paidAmount"
        label="已打款金额"
      >
        <template slot-scope="scope">
          ￥{{ scope.row.paidAmount || 0 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawStatusName"
        label="状态"
      >
        <template slot-scope="scope">
          {{ getStatusName(scope.row.withdrawStatus, scope.row.withdrawStatusName) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="rejectReasonName"
        label="备注"
      />
      <el-table-column
        prop="createTime"
        label="操作时间"
      >
        <template slot-scope="scope">
          {{ setTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="showWithdrawDetail(scope.row)"
          >
            提现详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 提现详情弹框 -->
    <el-dialog
      title="提现详情"
      :visible.sync="withdrawDetailDto.show"
      width="800px"
      :append-to-body="true"
      @close="resetWithdrawDetail"
    >
      <div v-if="withdrawDetailDto.data">
        <div style="margin-bottom: 20px;">
          <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
            提现金额：¥{{ withdrawDetailDto.data.withdrawAmount || 0 }}
          </div>
          <div v-if="withdrawDetailDto.data.platActualFee !== undefined || withdrawDetailDto.data.platCouponFee !== undefined" style="color: #666; font-size: 14px; margin-bottom: 20px;">
            （含平台实收：¥{{ withdrawDetailDto.data.platActualFee || 0 }}及平台补贴：¥{{ withdrawDetailDto.data.platCouponFee || 0 }}）
          </div>
        </div>

        <!-- 进度部分 -->
        <div style="margin-bottom: 30px;">
          <div style="font-size: 14px; font-weight: bold; margin-bottom: 15px;">进度</div>
          <el-timeline>
            <el-timeline-item
              v-for="(detail, index) in withdrawDetailDto.data.details"
              :key="index"
              :timestamp="dayFormat(detail.createTime)"
              :icon="getTimelineIcon(detail, index)"
              :type="getTimelineType(detail, index)"
              placement="top"
            >
              <div style="margin-bottom: 10px;">
                <div style="font-weight: bold; margin-bottom: 5px;">{{ detail.title }}</div>
                <div v-if="detail.remark" style="color: #666; margin-bottom: 5px;">
                  <div style="white-space: pre-wrap; margin-bottom: 8px;">说明:{{ getRemarkText(detail.remark) }}</div>
                  <div v-if="getRemarkImages(detail.remark).length > 0" style="margin-top: 8px;">
                    <el-image
                      v-for="(img, imgIndex) in getRemarkImages(detail.remark)"
                      :key="imgIndex"
                      :src="img"
                      :preview-src-list="getRemarkImages(detail.remark)"
                      style="width: 100px; height: 100px; margin-right: 10px; margin-bottom: 10px; cursor: pointer;"
                      fit="cover"
                    />
                  </div>
                </div>
                <div v-if="detail.paidTypeDesc" style="color: #666; margin-bottom: 5px;">
                  {{ detail.paidTypeDesc }}
                </div>
              </div>
            </el-timeline-item>
            <!-- 待打款和打款中状态：显示未到达的提现成功节点 -->
            <el-timeline-item
              v-if="withdrawDetailDto.data.withdrawStatus === 1 || withdrawDetailDto.data.withdrawStatus === 4"
              placement="top"
            >
              <div style="margin-bottom: 10px;">
                <div style="font-weight: bold; margin-bottom: 5px; color: #909399;">提现成功</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>

        <!-- 底部信息 -->
        <div style="border-top: 1px solid #EBEEF5; padding-top: 20px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
            <div>
              <span style="color: #666;">提现ID：</span>
              <span style="margin-right: 10px;">{{ withdrawDetailDto.data.withdrawId }}</span>
              <el-button
                type="text"
                size="mini"
                @click="copyWithdrawId(withdrawDetailDto.data.withdrawId)"
              >
                复制
              </el-button>
            </div>
          </div>
          <div>
            <span style="color: #666;">收款账户：</span>
            <span>{{withdrawDetailDto.data.accountBankName   }}</span>
            <span  style="margin-left: 10px; color: #999;">
              （{{withdrawDetailDto.data.receiveAccount || '-' }}）
            </span>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center; padding: 40px;">
        <i class="el-icon-loading" style="font-size: 24px;" />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          @click="withdrawDetailDto.show = false"
        >关 闭</el-button>
      </span>
    </el-dialog>
    <el-pagination
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pagination.nowPageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs';
// 提现记录
export default {
  name: 'withdraw-list-component',
  data() {
    return {
      tableData: [],
      loading: false,
      // 分页
      pagination: {
        currentPage: 1,
        nowPageSize: 10,
        count: 0,
      },
      // 提现详情
      withdrawDetailDto: {
        show: false,
        data: null,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 分页控制
    handleSizeChange(val) {
      this.pagination.nowPageSize = val;
      this.pagination.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$api.settlement.withdrawList,
        data: {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.nowPageSize,
          storeName: this.storeName,
          startTime: this.createStartTime ? this.createStartTime : null,
          endTime: this.createEndTime ? this.createEndTime : null,
        },
      }).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          console.log(this.tableData, '====');
          this.pagination.count = Number(res.data.total);
        } else {
          this.$message(res.error_msg);
        }
        this.loading = false;
      });
    },
    setTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    // 获取状态名称，支持打款中状态
    getStatusName(status, statusName) {
      // 根据API响应参数：1、待打款 2、已提现 3、提现失败 4、打款中
      if (status === 1) {
        return '待打款';
      } else if (status === 2) {
        return '已提现';
      } else if (status === 3) {
        return '提现失败';
      } else if (status === 4) {
        return '打款中';
      }
      return statusName || '';
    },
    // 显示提现详情
    async showWithdrawDetail(row) {
      this.withdrawDetailDto.show = true;
      this.withdrawDetailDto.data = null;
      
      try {
        const res = await this.$axios.get(this.$api.settlement.detail, {
          params: {
            withdrawId: row.withdrawId,
          },
        });
        
        if (res.code === 0) {
          // 从列表数据中获取平台实收和平台补贴金额（如果详情接口没有返回）
          if (res.data) {
            res.data.platActualFee = res.data.platActualFee !== undefined 
              ? res.data.platActualFee 
              : (row.platActualFee || 0);
            res.data.platCouponFee = res.data.platCouponFee !== undefined 
              ? res.data.platCouponFee 
              : (row.platCouponFee || 0);
          }
          this.withdrawDetailDto.data = res.data;
        } else {
          this.$message.error(res.error_msg || '获取详情失败');
          this.withdrawDetailDto.show = false;
        }
      } catch (err) {
        this.$message.error(err.error_msg || '获取详情失败');
        this.withdrawDetailDto.show = false;
      }
    },
    // 重置提现详情
    resetWithdrawDetail() {
      this.withdrawDetailDto.data = null;
    },
    // 复制提现ID
    copyWithdrawId(withdrawId) {
      const text = String(withdrawId);
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代 Clipboard API
        navigator.clipboard.writeText(text).then(() => {
          this.$message({ type: 'success', message: '复制成功' });
        }).catch(() => {
          this.$message({ type: 'error', message: '复制失败' });
        });
      } else {
        // 降级到传统方法
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            this.$message({ type: 'success', message: '复制成功' });
          } else {
            this.$message({ type: 'error', message: '复制失败' });
          }
        } catch (err) {
          this.$message({ type: 'error', message: '复制失败' });
        }
        
        document.body.removeChild(textArea);
      }
    },
    // 从备注中提取图片URL
    getRemarkImages(remark) {
      if (!remark) return [];
      // 匹配常见的图片URL格式
      const imageUrlRegex = /(https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|bmp|webp))/gi;
      const matches = remark.match(imageUrlRegex);
      return matches || [];
    },
    // 获取备注文本（去除图片URL）
    getRemarkText(remark) {
      if (!remark) return '';
      // 移除图片URL，保留文本
      const imageUrlRegex = /(https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|bmp|webp))/gi;
      return remark.replace(imageUrlRegex, '').trim();
    },
    // 格式化时间（用于详情弹框）
    dayFormat(val) {
      return val ? dayjs(+val).format('YYYY/MM/DD HH:mm:ss') : '-';
    },
    // 获取时间轴节点图标
    getTimelineIcon(detail, index) {
      // 只对成功和失败显示图标，其他使用默认
      if (detail.title && detail.title.includes('成功')) {
        return 'el-icon-success';
      } else if (detail.title && detail.title.includes('失败')) {
        return 'el-icon-error';
      }
      return '';
    },
    // 获取时间轴节点类型
    getTimelineType(detail, index) {
      // 只对成功和失败显示特殊类型，其他使用默认
      if (detail.title && detail.title.includes('成功')) {
        return 'success';
      } else if (detail.title && detail.title.includes('失败')) {
        return 'danger';
      }
      return '';
    },
  },
};
</script>
